var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.currentObject)?_c('div',{staticClass:"delete"},[_c('el-link',{attrs:{"underline":false,"type":"danger","icon":"el-icon-delete"},on:{"click":_vm.handleDelete}},[_vm._v(" Usuń ")])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }